import db from '../../config/databases/answers';
import imageDb from '../../config/databases/images';

export default async function getFailedAnswersFromLocal(formId) {
  const answers = await db.answers.where({ formId: Number(formId), status: 0 }).toArray();
  const imagesStatus0 = await imageDb.images.where({ formId: Number(formId), status: 0 }).toArray();
  const imagesStatus1 = await imageDb.images.where({ formId: Number(formId), status: 1 }).toArray();
  return {
    answers: answers.filter((ans) => ans.questionId && ans.questionType),
    images: [...imagesStatus0, ...imagesStatus1],
  };
}
